<template>
    <div
        v-if="siteData?.documents?.length"
        class="booking-list p-3 w-100 mr-2">
        <h3 class="font-weight-bold">
            Dokumente
        </h3>
        <div
            class="d-flex gap-2 flex-column flex-wrap"
            :class="row ? '' : 'flex-column'">
            <div
                v-for="document in siteData?.documents"
                :key="document.id">
                <a
                    :href="document.url"
                    target="_blank">
                    <font-awesome-icon
                        fixed-width
                        :icon="documentIcon(document)" />
                    <strong class="ml-1">{{ document.title || document.fileName }}</strong>
                </a>
            </div>
        </div>
    </div>
</template>

<script>

import mainSiteMixin from "@/mixins/mainSiteMixin";

export default {
    name: "DocumentList",
    mixins: [mainSiteMixin],
    methods: {
        documentIcon(document) {
            const extension = document.url.split('.').pop();
            switch (extension) {
                case "pdf":
                    return "file-pdf"
                case "docx":
                case "docm":
                case "doc":
                case "odt":
                    return "file-word"
                case "xls":
                case "xlsx":
                case "ods":
                case "csv":
                case "tsv":
                case "dat":
                    return "file-excel"
                case "png":
                case "gif":
                case "jpg":
                case "jpeg":
                case "svg":
                case "bmp":
                case "odi":
                    return "file-image"
                default:
                    return "file-alt"
            }
        }
    }
}
</script>

<style scoped>
.booking-list {
    width: 500px;
}
</style>
